/**
 * Normalize stored upload values (filename or /uploads/... path) to a browser URL.
 */
export function normalizeUploadFilename(value) {
  if (value == null) return '';
  const raw = String(value).trim();
  if (!raw) return '';

  if (raw.startsWith('/uploads/')) {
    return raw.slice('/uploads/'.length);
  }
  if (raw.startsWith('uploads/')) {
    return raw.slice('uploads/'.length);
  }
  return raw;
}

export function getUploadUrl(value) {
  const filename = normalizeUploadFilename(value);
  return filename ? `/uploads/${filename}` : '';
}

/**
 * Store uploads consistently as /uploads/<filename> for DB fields that expect a full path.
 */
export function toUploadPath(value) {
  const filename = normalizeUploadFilename(value);
  return filename ? `/uploads/${filename}` : '';
}
